import React from "react";
import { MessageWithAvatarAndReplyButton, ShowMoreHeightFade } from "@travellocal/ui";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./newMessage.scss";

interface NewItineraryMessage {
  enquiry: IEnquiry;
  message: IMessage;
  lto: ILto;
}

export const NewItineraryMessage: React.FC<NewItineraryMessage> = ({message, lto }) => {
  const { enquiryId, fromUser, text, sentTime } = message;

  const isLtoUser = fromUser?.userType === UserType.LtoEmployee;

  const messageWithAvatarProps = {
    avatarUrl: fromUser?.image
      ? fromUser.image.thumbnailUrl
      : "/images/anon.jpg",
    avatarName: `${fromUser?.firstName} from ${isLtoUser ? lto?.name : "TravelLocal"}`,
    ctaUrl: `${WebRoutes.customerEnquiryMessaging(enquiryId)}#link-from-new-message-card`,
    ctaCallback: () => GoogleAnalyticsHelper.logEvent("View message", "Click", "Itinerary tab"),
    sentTime,
  }

  return (
    <MessageWithAvatarAndReplyButton
      {...messageWithAvatarProps}
    >
      <ShowMoreHeightFade threshold={350} className="new-message-content">
        <div dangerouslySetInnerHTML={{ __html: text }}></div>
      </ShowMoreHeightFade>
    </MessageWithAvatarAndReplyButton>
  );
}
